import React, { Component } from 'react';
import { Product } from '@portal/portal-core';
import SeqGeqTab from 'components/user-account/product-tabs/seq-geq-tab';
import FlowJoTab from 'components/user-account/product-tabs/flowjo-tab';
import BDRCTab from 'components/user-account/product-tabs/bdrc-tab';
import InfinicytTab from 'components/user-account/product-tabs/infinicyt-tab';
import FacsWorkflowManagerTab from 'components/user-account/product-tabs/facs-workflow-manager-tab';

const { NAMES_UI_TABS } = Product;

interface AdminMarketingProps {
  product: string;
}

class AdminMarketing extends Component<AdminMarketingProps> {
  // If user is NOT an admin for a product, show the marketing copy from user account pages:
  renderMarketingContent(): React.ReactNode {
    switch (this.props.product) {
      case NAMES_UI_TABS.seqGeq:
        return <SeqGeqTab marketingContentOnly />;
      case NAMES_UI_TABS.flowJo:
        return <FlowJoTab marketingContentOnly />;
      case NAMES_UI_TABS.bdrc:
        return <BDRCTab marketingContentOnly />;
      case NAMES_UI_TABS.infinicytIvd:
        return <InfinicytTab marketingContentOnly productName={this.props.product} />;
      case NAMES_UI_TABS.infinicytRuo:
        return <InfinicytTab marketingContentOnly productName={this.props.product} />;
      case NAMES_UI_TABS.infinicytEa:
        return <InfinicytTab marketingContentOnly productName={this.props.product} />;
      case NAMES_UI_TABS.facsWorkflowManager:
        return <FacsWorkflowManagerTab marketingContentOnly />;
      default:
        return null;
    }
  }

  render(): React.ReactNode {
    return <div className="margin-right-1">{this.renderMarketingContent()}</div>;
  }
}

export default AdminMarketing;
